import { map } from 'lodash';
import React, { useMemo } from 'react';

import { FormikSelect, FormikSelectProps } from 'components';
import { OrderStatus } from 'enums';
import { orderUtils } from 'utils';

type Props = {
  name: string;
  label?: string;
  statuses?: OrderStatus[];
} & Partial<FormikSelectProps>;

export const OrderStatusSelect: React.FC<Props> = ({
  name,
  label,
  statuses,
  ...rest
}) => {
  const options = useMemo(
    () =>
      map(statuses, (status) => ({
        value: status,
        label: orderUtils.getStatusLabel(status),
      })),
    [statuses],
  );

  return (
    <FormikSelect
      noneOption
      label={label || ''}
      {...rest}
      name={name}
      options={options}
    />
  );
};
